module.exports = __webpack_public_path__ + "static/media/my.9bc65a4c.svg";